//oldcode

import {
  Layout,
  Menu,
  // Button,
  Typography,
  Modal,
} from "antd";
import React, { useState, useRef, useEffect } from "react";
import Logo from "../../assets/SpectusHRMS.png";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import "./index.css";
import LayoutStyle from "./LayoutStyle";
import Footer from "../../Components/Footer";
import Icon from "@ant-design/icons";
import LogoutAlertIcon from "../../assets/logoutalerticon.svg";
import {
  Dialog,
  DialogActions,
  DialogContent,
  Button,
  AppBar,
  Toolbar,
  IconButton,
  Box,
  Drawer,
} from "@mui/material";
import { toast } from "react-toastify";
import MenuIcon from "@mui/icons-material/Menu";
import { useDispatch, useSelector } from "react-redux";
import CryptoJS from 'crypto-js';
import { logout, setToken, setUserData } from "../../redux/slice/authSlice.js";
import { ReactComponent as LeaveIcon } from "../../assets/icon/leave.svg";
import { ReactComponent as AvailabilityIcon } from "../../assets/icon/EmployeeAvailability.svg";

const { default: env } = require("../../config/env.js");
const { Header, Content, Sider } = Layout;
const { Text } = Typography;
const SECRET_KEY = env.REACT_APP_ENCRYPTION_KEY;

function SiderLayout(props) {
  const path = useLocation().pathname;
  const secretKey = 'YourSecretKey';

  const logoutMouseOver = useRef();
  const navigate = useNavigate();
  const [currentPath, setCurrentPath] = useState(path);
  const [mobileOpen, setMobileOpen] = useState(false);
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  const dispatch = useDispatch();
  const token = useSelector((state) => state.auth.token);


  let Roles;
  if (props.role) {
    Roles = props.role;
  }


  useEffect(() => {
    if (Roles) { setCurrentPath(path); }
  }, [path]);

  const CompanyPolicyIcon = (props) => {
    return (
      <Icon
        component={() => {
          return (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              enable-background="new 0 0 24 24"
              height="24px"
              viewBox="0 0 24 24"
              width="24px"
            >
              <g>
                <rect fill="none" height="24" width="24" />
              </g>
              <g>
                <g />
                <g>
                  <path d="M12,1L3,5v6c0,5.55,3.84,10.74,9,12c5.16-1.26,9-6.45,9-12V5L12,1z M19,11c0,1.85-0.51,3.65-1.38,5.21l-1.45-1.45 c1.29-1.94,1.07-4.58-0.64-6.29c-1.95-1.95-5.12-1.95-7.07,0c-1.95,1.95-1.95,5.12,0,7.07c1.71,1.71,4.35,1.92,6.29,0.64 l1.72,1.72c-1.19,1.42-2.73,2.51-4.47,3.04C7.98,19.69,5,15.52,5,11V6.3l7-3.11l7,3.11V11z M12,15c-1.66,0-3-1.34-3-3s1.34-3,3-3 s3,1.34,3,3S13.66,15,12,15z" />
                </g>
              </g>
            </svg>
          );
        }}
        {...props}
      />
    );
  };

  const EmployeeLeaveIcon = (props) => {
    return (
      <Icon
        component={() => {
          return (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              enable-background="new 0 0 24 24"
              height="24px"
              viewBox="0 0 24 24"
              width="24px"
            >
              <g>
                <rect fill="none" height="24" width="24" />
              </g>
              <g>
                <g>
                  <path d="M4,16v6h16v-6c0-1.1-0.9-2-2-2H6C4.9,14,4,14.9,4,16z M18,18H6v-2h12V18z M12,2C9.24,2,7,4.24,7,7l5,7l5-7 C17,4.24,14.76,2,12,2z M12,11L9,7c0-1.66,1.34-3,3-3s3,1.34,3,3L12,11z" />
                </g>
              </g>
            </svg>
          );
        }}
        {...props}
      />
    );
  };
  
  const AllemployeeIcon = (props) => {
    return (
      <Icon
        component={() => {
          return (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              enable-background="new 0 0 24 24"
              height="24px"
              viewBox="0 0 24 24"
              width="24px"
            >
              <g>
                <rect fill="none" height="24" width="24" />
              </g>
              <g>
                <g>
                  <rect height="1.5" width="4" x="14" y="12" />
                  <rect height="1.5" width="4" x="14" y="15" />
                  <path d="M20,7h-5V4c0-1.1-0.9-2-2-2h-2C9.9,2,9,2.9,9,4v3H4C2.9,7,2,7.9,2,9v11c0,1.1,0.9,2,2,2h16c1.1,0,2-0.9,2-2V9 C22,7.9,21.1,7,20,7z M11,7V4h2v3v2h-2V7z M20,20H4V9h5c0,1.1,0.9,2,2,2h2c1.1,0,2-0.9,2-2h5V20z" />
                  <circle cx="9" cy="13.5" r="1.5" />
                  <path d="M11.08,16.18C10.44,15.9,9.74,15.75,9,15.75s-1.44,0.15-2.08,0.43C6.36,16.42,6,16.96,6,17.57V18h6v-0.43 C12,16.96,11.64,16.42,11.08,16.18z" />
                </g>
              </g>
            </svg>
          );
        }}
        {...props}
      />
    );
  };
  
  const DashboardIcon = (props) => {
    return (
      <Icon
        component={() => {
          return (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="24px"
              viewBox="0 0 24 24"
              width="24px"
              enable-background="new 0 0 24 24"
            >
              <g>
                <rect fill="none" height="24" width="24" />
              </g>
              <g>
                <g>
                  <path d="M19 5v2h-4V5h4M9 5v6H5V5h4m10 8v6h-4v-6h4M9 17v2H5v-2h4M21 3h-8v6h8V3zM11 3H3v10h8V3zm10 8h-8v10h8V11zm-10 4H3v6h8v-6z" />
                </g>
              </g>
            </svg>
          );
        }}
        {...props}
      />
    );
  };

  const LeaveSummaryIcon = (props) => {
    return (
      <Icon
        component={() => {
          return (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="24px"
              viewBox="0 0 24 24"
              width="24px"
              enable-background="new 0 0 24 24"
            >
              <g>
                <rect fill="none" height="24" width="24" />
              </g>
              <g>
                <g>
                  <path d="M19 3h-1V1h-2v2H8V1H6v2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V9h14v10zM5 7V5h14v2H5zm2 4h10v2H7zm0 4h7v2H7z" />
                </g>
              </g>
            </svg>
          );
        }}
        {...props}
      />
    );
  };

  const LogoutCustomICon = (props) => {
    return (
      <Icon
        component={() => {
          return (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              enable-background="new 0 0 24 24"
              height="24px"
              viewBox="0 0 24 24"
              width="24px"
              fill="rgb(36, 77, 160)"
            >
              <g>
                <rect fill="none" height="24" width="24" />
              </g>
              <g>
                <g>
                  <path d="M17,8l-1.41,1.41L17.17,11H9v2h8.17l-1.58,1.58L17,16l4-4L17,8z M5,5h7V3H5C3.9,3,3,3.9,3,5v14c0,1.1,0.9,2,2,2h7v-2H5V5z" />
                </g>
              </g>
            </svg>
          );
        }}
        {...props}
      />
    );
  };

  const ProfileCustomICon = (props) => {
    return (
      <Icon
        component={() => {
          return (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              enable-background="new 0 0 24 24"
              height="24px"
              viewBox="0 0 24 24"
              width="24px"
            >
              <g>
                <rect fill="none" height="24" width="24" />
              </g>
              <g>
                <g>
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM7.35 18.5C8.66 17.56 10.26 17 12 17s3.34.56 4.65 1.5c-1.31.94-2.91 1.5-4.65 1.5s-3.34-.56-4.65-1.5zm10.79-1.38C16.45 15.8 14.32 15 12 15s-4.45.8-6.14 2.12C4.7 15.73 4 13.95 4 12c0-4.42 3.58-8 8-8s8 3.58 8 8c0 1.95-.7 3.73-1.86 5.12z" />
                  <path d="M12 6c-1.93 0-3.5 1.57-3.5 3.5S10.07 13 12 13s3.5-1.57 3.5-3.5S13.93 6 12 6zm0 5c-.83 0-1.5-.67-1.5-1.5S11.17 8 12 8s1.5.67 1.5 1.5S12.83 11 12 11z" />
                </g>
              </g>
            </svg>
          );
        }}
        {...props}
      />
    );
  };

  const ChangePasswordIcon = (props) => {
    return (
      <Icon
        component={() => {
          return (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              enable-background="new 0 0 24 24"
              height="24px"
              viewBox="0 0 24 24"
              width="24px"
            >
              <g>
                <rect fill="none" height="24" width="24" />
              </g>
              <g>
                <g>
                  <path d="M13,3c-4.97,0-9,4.03-9,9c0,0.06,0.01,0.12,0.01,0.19l-1.84-1.84l-1.41,1.41L5,16l4.24-4.24l-1.41-1.41l-1.82,1.82 C6.01,12.11,6,12.06,6,12c0-3.86,3.14-7,7-7s7,3.14,7,7s-3.14,7-7,7c-1.9,0-3.62-0.76-4.88-1.99L6.7,18.42 C8.32,20.01,10.55,21,13,21c4.97,0,9-4.03,9-9S17.97,3,13,3z M15,11v-1c0-1.1-0.9-2-2-2s-2,0.9-2,2v1c-0.55,0-1,0.45-1,1v3 c0,0.55,0.45,1,1,1h4c0.55,0,1-0.45,1-1v-3C16,11.45,15.55,11,15,11z M14,11h-2v-1c0-0.55,0.45-1,1-1s1,0.45,1,1V11z" />
                </g>
              </g>
            </svg>
          );
        }}
        {...props}
      />
    );
  };

  const ApplyLeaveIcon = (props) => {
    return (
      <Icon
        component={() => {
          return (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="24px"
              viewBox="0 0 24 24"
              width="24px"
            >
              <g>
                <rect fill="none" height="24" width="24" />
              </g>
              <g>
                <g>
                  <path d="M18.19,12.44l-3.24-1.62c1.29-1,2.12-2.56,2.12-4.32c0-3.03-2.47-5.5-5.5-5.5s-5.5,2.47-5.5,5.5c0,2.13,1.22,3.98,3,4.89 v3.26c-2.15-0.46-2.02-0.44-2.26-0.44c-0.53,0-1.03,0.21-1.41,0.59L4,16.22l5.09,5.09C9.52,21.75,10.12,22,10.74,22h6.3 c0.98,0,1.81-0.7,1.97-1.67l0.8-4.71C20.03,14.32,19.38,13.04,18.19,12.44z M17.84,15.29L17.04,20h-6.3 c-0.09,0-0.17-0.04-0.24-0.1l-3.68-3.68l4.25,0.89V6.5c0-0.28,0.22-0.5,0.5-0.5c0.28,0,0.5,0.22,0.5,0.5v6h1.76l3.46,1.73 C17.69,14.43,17.91,14.86,17.84,15.29z M8.07,6.5c0-1.93,1.57-3.5,3.5-3.5s3.5,1.57,3.5,3.5c0,0.95-0.38,1.81-1,2.44V6.5 c0-1.38-1.12-2.5-2.5-2.5c-1.38,0-2.5,1.12-2.5,2.5v2.44C8.45,8.31,8.07,7.45,8.07,6.5z" />
                </g>
              </g>
            </svg>
          );
        }}
        {...props}
      />
    );
  };

  const MyLeaveIcon = (props) => {
    return (
      <Icon
        component={() => {
          return (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="24px"
              viewBox="0 0 24 24"
              width="24px"
            >
              <g>
                <rect fill="none" height="24" width="24" />
              </g>
              <g>
                <g>
                  <path d="M7 11h2v2H7v-2zm14-5v14c0 1.1-.9 2-2 2H5c-1.11 0-2-.9-2-2l.01-14c0-1.1.88-2 1.99-2h1V2h2v2h8V2h2v2h1c1.1 0 2 .9 2 2zM5 8h14V6H5v2zm14 12V10H5v10h14zm-4-7h2v-2h-2v2zm-4 0h2v-2h-2v2z" />
                </g>
              </g>
            </svg>
          );
        }}
        {...props}
      />
    );
  };

  const HolidaysIcon = (props) => {
    return (
      <Icon
        component={() => {
          return (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="24px"
              viewBox="0 0 24 24"
              width="24px"
            >
              <g>
                <rect fill="none" height="24" width="24" />
              </g>
              <g>
                <g>
                  <path d="M19,4h-1V2h-2v2H8V2H6v2H5C3.89,4,3.01,4.9,3.01,6L3,20c0,1.1,0.89,2,2,2h14c1.1,0,2-0.9,2-2V6C21,4.9,20.1,4,19,4z M19,20 H5V10h14V20z M19,8H5V6h14V8z M9,14H7v-2h2V14z M13,14h-2v-2h2V14z M17,14h-2v-2h2V14z M9,18H7v-2h2V18z M13,18h-2v-2h2V18z M17,18 h-2v-2h2V18z" />{" "}
                </g>
              </g>
            </svg>
          );
        }}
        {...props}
      />
    );
  };

  const TdsCalculationIcon = (props) => {
    return (
      <Icon
        component={() => {
          return (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              version="1.1"
              height="24px"
              width="24px"
              viewBox="0 0 122.88 127.03"
            >
              <g>
                <path d="M117.28,117.64l-2.32-2.67l-11,11l-0.01-0.01c-1.23,1.23-3.23,1.25-4.48,0.03l-11.21-10.9l-10.98,10.55 c-1.2,1.24-3.17,1.3-4.46,0.12L61.18,115L50.6,125.89c-0.06,0.07-0.12,0.13-0.19,0.21c-1.25,1.25-3.28,1.25-4.52,0L34.8,115 l-11.43,10.9l0,0c-1.25,1.19-3.24,1.17-4.46-0.06L8.03,114.85l-2.26,2.61c-0.58,0.79-1.52,1.29-2.57,1.29 c-1.77,0-3.19-1.44-3.19-3.19V3.19C0,1.43,1.43,0,3.19,0h116.49c1.77,0,3.19,1.43,3.19,3.19v112.35h-0.01 c0,0.89-0.37,1.78-1.11,2.41C120.44,119.12,118.42,118.97,117.28,117.64L117.28,117.64L117.28,117.64z M19.28,18.31H45.2v6.82h-8.7 v20.76h-8.51V25.13h-8.7V18.31L19.28,18.31z M63.38,41.34h-9.65l-1.39,4.54h-8.7l10.38-27.58h9.33l10.33,27.58h-8.92L63.38,41.34 L63.38,41.34z M61.57,35.37l-3.01-9.91l-3.02,9.91H61.57L61.57,35.37z M74.48,18.31h9.4l4.88,8.49l4.74-8.49h9.28l-8.57,13.36 l9.38,14.22h-9.59l-5.41-8.86l-5.45,8.86h-9.51l9.51-14.37L74.48,18.31L74.48,18.31z M91.22,88.04c1.3,0,2.36,1.05,2.36,2.36 c0,1.3-1.05,2.36-2.36,2.36H24.37c-1.3,0-2.36-1.05-2.36-2.36c0-1.3,1.05-2.36,2.36-2.36H91.22L91.22,88.04L91.22,88.04z M104.58,72.35c1.3,0,2.36,1.05,2.36,2.36c0,1.3-1.05,2.36-2.36,2.36H23.7c-1.3,0-2.36-1.05-2.36-2.36c0-1.3,1.05-2.36,2.36-2.36 H104.58L104.58,72.35L104.58,72.35z M104.7,56.64c1.3,0,2.36,1.05,2.36,2.36c0,1.3-1.06,2.36-2.36,2.36H23.7 c-1.3,0-2.36-1.05-2.36-2.36c0-1.3,1.05-2.36,2.36-2.36H104.7L104.7,56.64L104.7,56.64z M116.49,6.4H6.4v100.95 c1.13-0.59,2.54-0.47,3.57,0.41c0.06,0.05,0.12,0.1,0.18,0.17l0,0l11.09,11.21l11.42-10.88c1.26-1.2,3.24-1.17,4.46,0.05l0.01-0.01 l11,11l10.65-10.97c1.21-1.24,3.18-1.29,4.45-0.12l0,0l11.73,10.84l11.13-10.67c1.25-1.2,3.24-1.18,4.46,0.03l11.14,10.82 l11.2-11.2c0.96-0.98,2.43-1.19,3.62-0.63V6.4L116.49,6.4z" />
              </g>
            </svg>
          );
        }}
        {...props}
      />
    );
  };

  const EmployeeSalaryIcon = (props) => {
    return (
      <Icon
        component={() => {
          return (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              version="1.1"
              id="Layer_1"
              height="24"
              width="24"
              viewBox="0 0 256 240"
            >
              <path d="M84.635,20.256c18.383,0,33.286,14.903,33.286,33.286s-14.903,33.286-33.286,33.286S51.349,71.925,51.349,53.542  S66.251,20.256,84.635,20.256z M31.002,145.011c0-2.499,1.606-4.194,4.194-4.194s4.194,1.606,4.194,4.194v92.986h91.469v-92.986  c0-2.499,1.606-4.194,4.194-4.194c2.499,0,4.194,1.606,4.194,4.194v92.986h29.092V136.623c0-22.934-18.74-41.585-41.585-41.585  h-8.388l-24.451,38.015l-2.945-28.467l4.016-9.638H76.96l4.016,9.638l-3.123,28.645L53.401,95.038h-9.816  C20.651,95.038,2,113.778,2,136.623v101.375h29.092v-92.986H31.002z M197.036,24.057L189.972,2h40.376l-8.659,22.057H197.036z   M166.093,70.494c0-17.044,9.433-31.763,23.606-39.1h40.422C244.293,38.73,254,53.45,254,70.494c0,24.153-19.687,43.84-43.84,43.84  C185.734,114.333,166.093,94.647,166.093,70.494z M214.125,81.021c0,2.598-2.37,3.919-5.788,3.919c-3.965,0-7.61-1.322-10.254-2.643  l-1.823,7.064c2.324,1.322,6.289,2.37,10.481,2.643v5.788h6.015v-6.289c7.109-1.048,11.028-5.788,11.028-11.302  c0-5.514-2.917-8.886-10.254-11.53c-5.241-1.823-7.337-3.144-7.337-5.241c0-1.595,1.322-3.418,5.241-3.418  c4.466,0,7.337,1.322,8.932,2.096l1.823-6.836c-2.096-1.048-4.739-1.823-8.932-2.096v-5.514h-6.015v5.742  c-6.562,1.322-10.481,5.514-10.481,11.028c0,6.061,4.466,9.205,11.028,11.302C212.257,77.329,214.353,78.651,214.125,81.021z" />
            </svg>
          );
        }}
        {...props}
      />
    );
  };
  
  const AllowanceIcon = (props) => {
    return (
      <Icon
        component={() => {
          return (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              version="1.1"
              height="24"
              width="24"
              viewBox="0 0 256 256"
            >
              <defs></defs>
              <g transform="translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)">
                <path
                  d="M 48 1.448 c -11.871 0 -21.529 9.658 -21.529 21.529 S 36.129 44.507 48 44.507 s 21.529 -9.658 21.529 -21.529 S 59.871 1.448 48 1.448 z M 45.635 19.003 c 0.297 0.793 0.938 1.386 1.758 1.627 l 0.125 0.041 l 2.284 0.837 c 2.004 0.61 3.572 2.079 4.308 4.039 c 1.295 3.453 -0.461 7.313 -3.912 8.608 c -0.065 0.024 -0.132 0.032 -0.197 0.055 v 0.984 c 0 1.104 -0.896 2 -2 2 s -2 -0.896 -2 -2 v -0.882 c -0.31 -0.09 -0.617 -0.195 -0.917 -0.331 c -1.625 -0.739 -2.866 -2.067 -3.493 -3.739 c -0.388 -1.035 0.136 -2.187 1.17 -2.575 c 1.036 -0.39 2.187 0.137 2.575 1.17 c 0.252 0.671 0.75 1.205 1.403 1.501 s 1.382 0.321 2.054 0.07 c 1.387 -0.52 2.092 -2.071 1.571 -3.458 c -0.298 -0.793 -0.938 -1.386 -1.757 -1.627 l -0.125 -0.041 l -2.284 -0.837 c -2.005 -0.611 -3.573 -2.08 -4.308 -4.04 c -0.627 -1.672 -0.565 -3.488 0.174 -5.114 c 0.739 -1.625 2.067 -2.866 3.739 -3.493 c 0.065 -0.025 0.132 -0.041 0.197 -0.063 v -0.976 c 0 -1.104 0.896 -2 2 -2 s 2 0.896 2 2 v 0.885 c 1.959 0.568 3.639 2.014 4.409 4.066 c 0.389 1.034 -0.136 2.187 -1.169 2.575 c -1.034 0.389 -2.188 -0.136 -2.575 -1.17 c -0.521 -1.387 -2.073 -2.094 -3.458 -1.572 C 45.821 16.066 45.116 17.617 45.635 19.003 z"
                  transform=" matrix(1 0 0 1 0 0) "
                  stroke-linecap="round"
                />
                <path
                  d="M 33.041 79.838 l -7.985 8.74 c -0.086 0.094 -0.188 0.119 -0.259 0.121 c -0.076 0.012 -0.175 -0.012 -0.27 -0.098 L 0.122 66.305 C 0.027 66.219 0.003 66.116 0 66.046 c -0.003 -0.071 0.011 -0.174 0.098 -0.27 l 7.985 -8.74 c 0.086 -0.094 0.188 -0.119 0.258 -0.121 c 0.006 -0.001 0.012 -0.001 0.018 -0.001 c 0.07 0 0.165 0.019 0.252 0.099 l 24.405 22.296 C 33.169 79.448 33.18 79.684 33.041 79.838 z"
                  transform=" matrix(1 0 0 1 0 0) "
                  stroke-linecap="round"
                />
                <path
                  d="M 89.171 43.946 L 72.605 63.168 c -3.831 4.344 -5.012 6.835 -10.803 6.835 h -20.16 c -2.9 0 -5.847 1.058 -8.484 2.986 l -17.623 -16.1 c 8.048 -7.48 17.169 -9.806 27.816 -7.099 l 0.288 0.073 h 19.916 c 1.815 0 3.293 1.477 3.293 3.294 c 0 1.815 -1.477 3.293 -3.293 3.293 l -19.457 3.515 c -1.3 0.194 -2.197 1.405 -2.004 2.705 c 0.175 1.182 1.191 2.03 2.351 2.03 c 0.116 0 0.235 -0.008 0.353 -0.026 l 18.947 -3.466 c 4.353 -0.102 7.863 -3.674 7.863 -8.051 c 0 -1.016 -0.197 -1.985 -0.542 -2.881 l 13.079 -10.683 l 0.163 -0.152 c 1.176 -1.21 3.072 -1.345 4.406 -0.311 c 0.732 0.567 1.184 1.387 1.271 2.308 C 90.072 42.361 89.784 43.251 89.171 43.946 z"
                  transform=" matrix(1 0 0 1 0 0) "
                  stroke-linecap="round"
                />
              </g>
            </svg>
          );
        }}
        {...props}
      />
    );
  };

  const [open, setOpen] = useState(false);

  if (!token) return <>{<Outlet />}</>;

  const logoutHandler = () => {
    setOpen(true);
  };

  const handleOk = async () => {
    try {

      const logout = CryptoJS.SHA256("/logout" + SECRET_KEY).toString(CryptoJS.enc.Hex).substring(0, 12);

      const response = await fetch(`${env.backend_api_endpoint}/${logout}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: token,
        },
      });

      if (!response.ok) {
        const errorData = await response.json();
      }

      if (response.ok) {
        const successData = await response.json();
        if (successData.status === 200) {

          dispatch(setToken(null));
          dispatch(setUserData(null));
          toast.success("Logout Successfully !", {
            position: toast.POSITION.TOP_RIGHT,
            toastId: "1",
          });
          navigate("/login");
        }
      }
    } catch (error) {
      console.error("Error Login in:", error.message);
    }
  };

  const handleCancel = () => {
    setOpen(false);
  };

  const routes = {
    1: "/users",
    2: "/invitations",
    3: "/leaves",
    4: "/myleaves",
    5: "/myleaves/applyleave",
    6: "/myleaves/leavesummary",
    7: "/profile",
    8: "/changePassword",
    11: "/",
    12: "/allemployee",
    13: "/employeeleave",
    // 14: "/account",
    15: "/companypolicy",
    16: "/spectusholidays",
    // 17: "/allowance",
    // 18: "/tds-calculation",
    19: "/attendance",
    20: "/employeeavailability",
    23: "/employeeCompanypolicy",
  };
  
  const onSiderClick = (key) => {
    const route = routes[key?.key];

    if (route) {
      navigate(route);
    } else {
      console.warn(`${key?.key} not in routes map`);
    }
  };

  const handleLogo = () => {
    navigate("/");
    window.location.reload();
  };

  const drawer = (
    <>
      <Header
        className="site-layout-sub-header-background"
        style={{
          display: "flex",
          alignItems: "center",
          padding: "0 20px",
          justifyContent: "center",
          cursor: "pointer",
          backgroundColor: "white",
          margin: "40px 0",
        }}
      >
        <a href={"javascript:void(0);"} onClick={handleLogo}>
          <div style={{ display: "flex", backgroundColor: "white" }}>
            <img
              src={Logo}
              alt="logo"
              style={{
                margin: "auto",
                width: "100%",
                maxWidth: "400px",
                height: "auto",
              }}
            />
          </div>
        </a>
      </Header>
      <Menu
        mode="inline"
        style={{
          color: "#244DA0",
          height: "75vh",
          overflowY: "scroll",
          overflowX: "hidden",
          scrollbarWidth: "none",
          scrollbarColor: "red",
        }}
        selectedKeys={""}
        className="itemsList"
      >
        <Menu.Item
          className={`CompanyPolicy ${currentPath === "/" ? "ant-menu-item-selected" : ""
            }`}
          key="11"
          onClick={() => {
            setMobileOpen(false);
            navigate(`/`);
          }}
          style={{
            fontFamily: "MilliardMedium",
            fontSize: "15px",
            fontWeight: "500",
          }}
        >
          <DashboardIcon />
          <span className="customcss">Dashboard</span>
        </Menu.Item>
        <Menu.Item
          className={`CompanyPolicy ${currentPath === "/spectusholidays" ? "ant-menu-item-selected" : ""
            }`}
          key="16"
          onClick={(key) => {
            setMobileOpen(false);
            onSiderClick(key);
          }}
          style={{
            fontFamily: "MilliardMedium",
            fontSize: "15px",
            fontWeight: "500",
          }}
        >
          <HolidaysIcon />
          <span className="customcss">Spectus Holidays</span>
        </Menu.Item>
        {Roles !== 3 && (
          <Menu.ItemGroup
            title={
              <div style={{ color: "#244DA0", fontWeight: "600" }}>Leaves</div>
            }
            style={{
              fontFamily: "Milliard",
              fontSize: "15px",
              fontWeight: "500",
            }}
          >
            <Menu.Item
              key="5"
              onClick={(key) => {
                setMobileOpen(false);
                onSiderClick(key);
              }}
              className={`CompanyPolicy ${currentPath === "/myleaves/applyleave"
                ? "ant-menu-item-selected"
                : ""
                }`}
              style={{
                fontFamily: "MilliardMedium",
                fontSize: "15px",
                fontWeight: "500",
              }}
            >
              <ApplyLeaveIcon />
              <span className="customcss">Apply Leave</span>
            </Menu.Item>
            <Menu.Item
              key="4"
              onClick={(key) => {
                setMobileOpen(false);
                onSiderClick(key);
              }}
              className={`CompanyPolicy ${currentPath === "/myleaves" ? "ant-menu-item-selected" : ""
                }`}
              style={{
                fontFamily: "MilliardMedium",
                fontSize: "15px",
                fontWeight: "500",
              }}
            >
              <MyLeaveIcon />

              <span className="customcss">My leaves</span>
            </Menu.Item>
            <Menu.Item
              key="6"
              onClick={(key) => {
                setMobileOpen(false);
                onSiderClick(key);
              }}
              className={`CompanyPolicy ${currentPath === "/myleaves/leavesummary"
                ? "ant-menu-item-selected"
                : ""
                }`}
              style={{
                fontFamily: "MilliardMedium",
                fontSize: "15px",
                fontWeight: "500",
              }}
            >
              <LeaveSummaryIcon />
              <span className="customcss">Leaves Summary</span>
            </Menu.Item>
            <Menu.Item
              key="19"
              onClick={(key) => {
                setMobileOpen(false);
                onSiderClick(key);
              }}
              className={`CompanyPolicy ${currentPath === "/attendance" ? "ant-menu-item-selected" : ""
                }`}
              style={{
                fontFamily: "MilliardMedium",
                fontSize: "15px",
                fontWeight: "500",
              }}
            >
              <LeaveSummaryIcon />
              <span className="customcss">Attendance</span>
            </Menu.Item>
          </Menu.ItemGroup>
        )}
        {Roles == 3 && (
          <Menu.ItemGroup
            title={
              <div style={{ color: "#244DA0", fontWeight: "600" }}>
                Employee
              </div>
            }
            style={{
              fontFamily: "MilliardMedium",
              fontSize: "15px",
              fontWeight: "500",
              marginBottom: "1px",
            }}
          >
            <Menu.Item
              key="12"
              onClick={(key) => {
                setMobileOpen(false);
                onSiderClick(key);
              }}
              className={`CompanyPolicy ${currentPath === "/allemployee" ? "ant-menu-item-selected" : ""
                }`}
              style={{
                fontFamily: "MilliardMedium",
                fontSize: "15px",
                fontWeight: "500",
              }}
            >
              <AllemployeeIcon />
              <span className="customcss">All Employee</span>
            </Menu.Item>

            <Menu.Item
              key="13"
              onClick={(key) => {
                setMobileOpen(false);
                onSiderClick(key);
              }}
              className={`CompanyPolicy ${currentPath === "/employeeleave" ? "ant-menu-item-selected" : ""}`}
              style={{
                fontFamily: "MilliardMedium",
                fontSize: "15px",
                fontWeight: "500",
              }}
            >
              <div className="menu-item-flex">
                <LeaveIcon className="itemIcon" />
                <span className="customcss">Employee Leaves</span>
              </div>
            </Menu.Item>

            <Menu.Item
              key="20"
              onClick={(key) => {
                setMobileOpen(false);
                onSiderClick(key);
              }}
              className={`CompanyPolicy ${currentPath === "/employeeavailability"
                ? "ant-menu-item-selected"
                : ""
                }`}
              style={{
                fontFamily: "MilliardMedium",
                fontSize: "15px",
                fontWeight: "500",
              }}
            >
              {/* <EmployeeLeaveIcon /> */}
              <div className="menu-item-flex">
                <AvailabilityIcon className="itemIcon" />
                <span className="customcss">Employee Availability</span>
              </div>
            </Menu.Item>
          </Menu.ItemGroup>
        )}
        {/* {Roles == "3" ? (
              <Menu.ItemGroup
                title={
                  <div style={{ color: "#244DA0", fontWeight: "600" }}>
                    Account
                  </div>
                }
                style={{
                  fontFamily: "Milliard",
                  fontSize: "15px",
                  fontWeight: "500",
                  marginBottom: "1px",
                }}>
                <Menu.Item
                  key="14"
                 onClick={(key) => { setMobileOpen(false); onSiderClick(key) }}
                  className={`CompanyPolicy ${currentPath === "/account"
                    ? "ant-menu-item-selected"
                    : ""
                    }`}>
                  <EmployeeSalaryIcon />
                  <span className="customcss">Employee Salary</span>
                </Menu.Item>
                <Menu.Item
                  key="17"
                 onClick={(key) => { setMobileOpen(false); onSiderClick(key) }}
                  className={`CompanyPolicy ${currentPath === "/allowance"
                    ? "ant-menu-item-selected"
                    : ""
                    }`}>
                  <AllowanceIcon />
                  <span className="customcss">Allowances</span>
                </Menu.Item>
                <Menu.Item
                  key="18"
                 onClick={(key) => { setMobileOpen(false); onSiderClick(key) }}
                  className={`CompanyPolicy ${currentPath === "/tds-calculation"
                    ? "ant-menu-item-selected"
                    : ""
                    }`}>
                  <TdsCalculationIcon />
                  <span className="customcss">TDS Calculation</span>
                </Menu.Item>
              </Menu.ItemGroup>
            ) : null} */}

        <Menu.ItemGroup
          title={
            <div style={{ color: "#244DA0", fontWeight: "600" }}>General</div>
          }
          style={{
            fontFamily: "MilliardMedium",
            fontSize: "15px",
            fontWeight: "500",
          }}
        >
          {Roles == 3 && (
            <Menu.Item
              key="15"
              className={`CompanyPolicy ${currentPath === "/companypolicy" ? "ant-menu-item-selected" : ""
                }`}
              style={{
                fontFamily: "MilliardMedium",
                fontSize: "15px",
                fontWeight: "500",
              }}
              onClick={(key) => {
                setMobileOpen(false);
                onSiderClick(key);
              }}
            >
              <CompanyPolicyIcon />
              <span className="customcss">Company Policy</span>
            </Menu.Item>
          )}
          {Roles !== 3 && (
            <Menu.Item
              key="23"
              className={`CompanyPolicy ${currentPath === "/employeeCompanypolicy"
                ? "ant-menu-item-selected"
                : ""
                }`}
              style={{
                fontFamily: "MilliardMedium",
                fontSize: "15px",
                fontWeight: "500",
              }}
              onClick={(key) => {
                setMobileOpen(false);
                onSiderClick(key);
              }}
            >
              <CompanyPolicyIcon />
              <span className="customcss">Company Policy</span>
            </Menu.Item>
          )}
          <Menu.Item
            className={`CompanyPolicy ${currentPath === "/profile" ? "ant-menu-item-selected" : ""
              }`}
            key="7"
            onClick={(key) => {
              setMobileOpen(false);
              onSiderClick(key);
            }}
            style={{
              fontFamily: "MilliardMedium",
              fontSize: "15px",
              fontWeight: "500",
              marginBottom: "1px",
            }}
          >
            <ProfileCustomICon />
            <span className="customcss">Profile</span>
          </Menu.Item>
          <Menu.Item
            className={`CompanyPolicy ${currentPath === "/changePassword" ? "ant-menu-item-selected" : ""
              }`}
            key="8"
            onClick={(key) => {
              setMobileOpen(false);
              onSiderClick(key);
            }}
            style={{
              fontFamily: "MilliardMedium",
              fontSize: "15px",
              fontWeight: "500",
              marginBottom: "1px",
            }}
          >
            <ChangePasswordIcon />
            <span className="customcss">Change Password</span>
          </Menu.Item>
        </Menu.ItemGroup>
        <div
          className="CompanyPolicy logouthover"
          ref={logoutMouseOver}
          key="10"
          onClick={logoutHandler}
          style={{
            fontFamily: "MilliardMedium",
            fontSize: "15px",
            fontWeight: "500",
            paddingLeft: "24px",
            height: "40px",
            display: "flex",
            alignItems: "center",
          }}
        >
          <LogoutCustomICon />
          <span className="customcss" style={{ marginLeft: "10px" }}>
            Logout
          </span>
        </div>
        <div class="modalStyle">
          <Dialog open={open} onClose={handleCancel} width={700}>
            <DialogContent>
              <center>
                <img
                  src={LogoutAlertIcon}
                  alt=""
                  style={{ height: "50px", width: "50px" }}
                />
              </center>
              <p
                style={{
                  fontWeight: "600",
                  fontSize: "18px",
                  textAlign: "center",
                  marginTop: "15px",
                  color: " rgba(0, 0, 0, 0.66)",
                }}
              >
                Are you sure you want to logout?
              </p>
            </DialogContent>
            <DialogActions
              style={{ justifyContent: "center", marginBottom: "10px" }}
            >
              <Button
                onClick={handleCancel}
                style={{
                  backgroundColor: "#E20E0E",
                  borderRadius: "6px",
                  color: "white",
                  fontWeight: "500",
                  borderColor: "#E20E0E",
                  width: "130px",
                  textTransform: "none",
                  fontFamily: "MilliardMedium"
                }}
              >
                Cancel
              </Button>
              <Button
                onClick={handleOk}
                style={{
                  backgroundColor: "#244DA0",
                  borderRadius: "6px",
                  fontWeight: "500",
                  borderColor: "#244DA0",
                  color: "white",
                  width: "130px",
                  textTransform: "none",
                  fontFamily: "MilliardMedium"
                }}
              >
                Logout
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      </Menu>
    </>
  );

  return (
    <LayoutStyle>
      <Layout hasSider>
        <Sider className="MainSider">
          <Box
            component="nav"
            sx={{ width: { sm: 250 }, flexShrink: { sm: 0 } }}
          >
            <Drawer
              variant="temporary"
              open={mobileOpen}
              onClose={handleDrawerToggle}
              // ModalProps={{
              //   keepMounted: true,
              // }}
              sx={{
                display: {
                  xs: "block",
                  sm: "block",
                  md: "block",
                  lg: "block",
                  xl: "none",
                },
                "& .MuiDrawer-paper": { boxSizing: "border-box", width: 250 },
              }}
            >
              {drawer}
            </Drawer>
            <Drawer
              variant="permanent"
              sx={{
                display: {
                  xs: "none",
                  sm: "none",
                  xl: "block",
                  lg: "block",
                  md: "block",
                },
                "& .MuiDrawer-paper": { boxSizing: "border-box", width: 250 },
              }}
              open
            >
              {drawer}
            </Drawer>
          </Box>
        </Sider>
        <AppBar
          position="fixed"
          sx={{
            width: { sm: `calc(100%)` },
            display: { xl: "none", lg: "none", md: "none" },
            backgroundColor: "transparent",
            color: "black",
            boxShadow: "none",
          }}
        >
          <Toolbar>
            <IconButton
              color="inherit"
              aria-label="open drawer"
              edge="start"
              onClick={handleDrawerToggle}
              sx={{ mr: 2 }}
            >
              <MenuIcon />
            </IconButton>
          </Toolbar>
        </AppBar>
        <Footer />
      </Layout>
    </LayoutStyle>
  );
}

export default SiderLayout;